"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var html_1 = require("./nodes/html");
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return html_1.parse;
  }
});